module.exports = __webpack_public_path__ + "static/house-0df8c588d32ade4a2fa4f4c033b73393.png";